import { lazy, Suspense, useState, useEffect } from 'react';
import { useRoutes, NonIndexRouteObject } from 'react-router-dom';
import useControlRoute from 'hooks/useControlRoutes';
import useNotifyInfo from 'hooks/useNotifyInfo';
import axios from 'axios';

import PageLoading from 'components/PageLoading';
import DialogDisclaimer from 'components/DialogDisclaimer';

export interface RouteConfig extends NonIndexRouteObject {
  name?: string;
}

export interface ControlInfo {
  app_name: string;
  start_date: number;
  end_date?: number;
  title?: string;
  message?: string;
}

const Login = lazy(() => import('pages/login'));
const Home = lazy(() => import('pages/home'));
const SDLA = lazy(() => import('pages/sdla'));
const SCT = lazy(() => import('pages/sct'));
const FWT = lazy(() => import('pages/ft'));
const PC = lazy(() => import('pages/pc'));
const FC = lazy(() => import('pages/fc'));
// const RP = lazy(() => import('pages/rp'));
const WOM = lazy(() => import('pages/wom'));
const Support = lazy(() => import('pages/support'));
const Callback = lazy(() => import('pages/callback'));
const NoPermission = lazy(() => import('pages/no-permissoin'));

const Router = () => {
  const [controlData, setControlData] = useState<ControlInfo[] | null>(null);

  useEffect(() => {
    // Fetch control data
    const fetchControlData = async () => {
      try {
        const response = await axios.get<ControlInfo[]>('/system/maintain');

        setControlData(response.data);
      } catch (error) {
        setControlData(null);
      }
    };

    fetchControlData();
  }, []);

  useNotifyInfo(controlData);

  const controlledRouteConfig = useControlRoute(routeConfig, controlData);
  const routes = useRoutes(controlledRouteConfig);

  return (
    <>
      {routes}
      <DialogDisclaimer />
    </>
  );
};

export const routeConfig: RouteConfig[] = [
  {
    path: '/',
    element: <Suspense fallback={<PageLoading />}>{<Home />}</Suspense>,
  },
  {
    name: 'server_log_advisor',
    path: '/sdla/*',
    element: <Suspense fallback={<PageLoading />}>{<SDLA />}</Suspense>,
  },
  {
    name: 'compatibility_tool',
    path: '/sct/*',
    element: <Suspense fallback={<PageLoading />}>{<SCT />}</Suspense>,
  },
  {
    name: 'firmware_tracker',
    path: '/firmware-tracker/*',
    element: <Suspense fallback={<PageLoading />}>{<FWT />}</Suspense>,
  },
  {
    name: 'power_calculator',
    path: '/power-calculator/*',
    element: <Suspense fallback={<PageLoading />}>{<PC />}</Suspense>,
  },
  {
    name: 'firmware_customization',
    path: '/firmware-customization/*',
    element: <Suspense fallback={<PageLoading />}>{<FC />}</Suspense>,
  },
  // {
  //   name: 'registration_portal',
  //   path: '/registration/*',
  //   element: <Suspense fallback={<PageLoading />}>{<RP />}</Suspense>,
  // },
  {
    path: '/wom/*',
    element: <Suspense fallback={<PageLoading />}>{<WOM />}</Suspense>,
  },
  {
    path: '/support/*',
    element: <Suspense fallback={<PageLoading />}>{<Support />}</Suspense>,
  },
  {
    path: '/login',
    element: <Suspense fallback={<PageLoading />}>{<Login />}</Suspense>,
  },
  {
    path: '/callback',
    element: <Suspense fallback={<PageLoading />}>{<Callback />}</Suspense>,
  },
  {
    path: '/no-permission',
    element: <Suspense fallback={<PageLoading />}>{<NoPermission />}</Suspense>,
  },
  {
    path: '*',
    element: <div>404</div>,
  },
];

export default Router;
